// Generated by CoffeeScript 2.7.0
var Admin__Settings__NamecardsController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsNamecard from 'trunks/vue/admin/components/settings/settings_container/settings_namecard.js';

export default Admin__Settings__NamecardsController = (function() {
  class Admin__Settings__NamecardsController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__namecard');
      return Skylark.Libs.Ajax.get('/admin/settings/namecard.json', {
        success: (data) => {
          return new SettingsNamecard({
            el: DomMaster.find('#js-settings-namecard').node,
            propsData: {
              activeTab: 'namecard',
              namecardData: data
            }
          });
        }
      });
    }

  };

  Admin__Settings__NamecardsController.include(GenerateMorePopover);

  Admin__Settings__NamecardsController.include(SettingsNavigator);

  return Admin__Settings__NamecardsController;

}).call(this);
